import { Routes } from "@angular/router";
import { PublicationListComponent } from "./modules/publications/publication-list/publication-list.component";
import { CopyComponent } from "./modules/copy/copy.component";
import { COPY_URI, ERROR, PUBLICATION_URI } from "./variables/uri";
import { AuthGuard } from "./guards/auth.guard";
import { NotAuthenticatedPageComponent } from "./modules/error-page/not-authenticated-page/not-authenticated-page.component";

export const routes: Routes = [
    {
        path: "",
        component: PublicationListComponent,
        pathMatch: "full",
        canActivate: [AuthGuard],
    },
    {
        path: COPY_URI,
        component: CopyComponent,
        pathMatch: "full",
        canActivate: [AuthGuard],
    },
    {
        path: PUBLICATION_URI + "/:id",
        loadComponent: () =>
            import(
                "./modules/publications/publication-item/publication-item.component"
            ).then((m) => m.PublicationItemComponent),
        canActivate: [AuthGuard],
        children: [
            {
                path: "**",
                loadComponent: () =>
                    import("./modules/section/section.component").then(
                        (m) => m.SectionComponent,
                    ),
                canActivate: [AuthGuard],
            },
        ],
    },
    {
        path: ERROR.NOT_AUTHENTICATED,
        component: NotAuthenticatedPageComponent,
    },
];
